// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "passenger-nE6zv";
var _5 = "short-mtv_1";
var _6 = "notification__title-2Xh7b";
var _7 = "header-TrXxO";
var _8 = "withoutServices-3W9lT";
var _9 = "header_notInteractive-1PkDP";
var _a = "header__text-UFE8A";
var _b = "header__text_notpassed-3-j08";
var _c = "passenger_readonly-2jIPz";
var _d = "header__additional-QU5tI";
var _e = "header__date-35QeP";
var _f = "header__services-20FXD";
var _10 = "services__label-3KFvr";
var _11 = "services__price-URxn5";
var _12 = "services__price_null-1ZKmT";
var _13 = "form__container-3EKMN";
var _14 = "edit-2ybeA";
var _15 = "form-fmsYM";
var _16 = "form_other-3CDJl";
var _17 = "form_identy-1MHTB";
var _18 = "form__field_gender-13j_Y";
var _19 = "form__field-1XIlr";
var _1a = "form__field_loyaltyCardHint-3K6XP";
var _1b = "form__field_birthday-2SVUQ";
var _1c = "toggle_opened-1lxij";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "passenger", _5 as "short", _6 as "notification__title", _7 as "header", _8 as "withoutServices", _9 as "header_notInteractive", _a as "header__text", _b as "header__text_notpassed", _c as "passenger_readonly", _d as "header__additional", _e as "header__date", _f as "header__services", _10 as "services__label", _11 as "services__price", _12 as "services__price_null", _13 as "form__container", _14 as "edit", _15 as "form", _16 as "form_other", _17 as "form_identy", _18 as "form__field_gender", _19 as "form__field", _1a as "form__field_loyaltyCardHint", _1b as "form__field_birthday", _1c as "toggle_opened" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "passenger": _4, "short": _5, "notification__title": _6, "header": _7, "withoutServices": _8, "header_notInteractive": _9, "header__text": _a, "header__text_notpassed": _b, "passenger_readonly": _c, "header__additional": _d, "header__date": _e, "header__services": _f, "services__label": _10, "services__price": _11, "services__price_null": _12, "form__container": _13, "edit": _14, "form": _15, "form_other": _16, "form_identy": _17, "form__field_gender": _18, "form__field": _19, "form__field_loyaltyCardHint": _1a, "form__field_birthday": _1b, "toggle_opened": _1c }
